import request from '@/utils/request';

// 学生列表
export function getStuList(data) {
  return request({
    url: '/course/front/class/frontStudentList',
    method: 'post',
    data
  });
}

// 返回有课程的日期集合
export function getWeekData(data) {
  return request({
    url: '/course/front/class/checkDay',
    method: 'post',
    data
  });
}

// 课程表
export function getCourseSchedule(data) {
  return request({
    url: '/course/front/class/schedule',
    method: 'post',
    data
  });
}

// 我的课程
export function getMyCourse(data) {
  return request({
    url: '/course/front/class/myCourse',
    method: 'post',
    data
  });
}

// 我的课程new
export function getMyCoursev2(data) {
  return request({
    url: '/course/front/class/myCourse/v2',
    method: 'post',
    data
  });
}

// 根据班级id获取直播课目录
export function getCourseMenu(data) {
  return request({
    url: '/course/front/live/courseCatalog',
    method: 'post',
    data
  });
}

// 根据班级id获取面授课目录
export function getFaceCourseMenu(data) {
  return request({
    url: '/course/front/live/classCatalog',
    method: 'post',
    data
  });
}

// 获取直播的跳转地址信息
export function getLivePath(data) {
  return request({
    url: '/course/front/live/checkLive',
    method: 'post',
    data
  });
}

// 如果是直播课的历史课程，点击回放，跳转的地址
export function getHistoryPath(data) {
  return request({
    url: '/course/front/live/checkPlayback',
    method: 'post',
    data
  });
}

// 课程详情页，获取课程信息
export function getCourseInfo(params) {
  return request({
    url: `course/front/live/detail/${params}`,
    method: 'get'
  });
}

// 根据班级id获取录播课目录
export function getRecordCourseMenu(data) {
  return request({
    url: '/course/front/course/classCatalog',
    method: 'post',
    data
  });
}

// 根据录播课课次id校验课次的有效性
export function checkRecordUrl(data) {
  return request({
    url: '/course/front/live/classCatalog',
    method: 'post',
    data
  });
}

// 根据录播课id获取录播课视频地址
export function getRecordUrls(lessonId) {
  return request({
    url: `/course/front/course/videoUrl/${lessonId}`,
    method: 'get'
  });
}

// 课程详情页，获取录播课程信息
export function getRecordInfo(courseId) {
  return request({
    url: `/course/front/course/detail/${courseId}`,
    method: 'get'
  });
}



// WEBPACK FOOTER //
// ./src/api/study/index.js